import React, { useState, useEffect, useMemo, useRef } from "react";
import { useTable, useGlobalFilter } from 'react-table';
import axios from "axios";
import { parse, isValid } from 'date-fns';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from './DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import './reconSummary.css';
import Select from "react-select";
import EditIcon from '@mui/icons-material/Edit';
import excelIcon from '../../../assets/images/excel.png'; // Ensure these icons exist
import pdfIcon from '../../../assets/images/pdf.png';
import logo from '../../../assets/images/1.png'; // Adjust the path to your image
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import * as XLSX from "xlsx"; // For Excel
import jsPDF from "jspdf"; // For PDF
import "jspdf-autotable"; // For PDF Table
import moment from 'moment';

function PurchaseRequirement() {
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [tablerowData, settableRowData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [tablecolumnDefs, settableColumnDefs] = useState([]);
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.entities_id,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchprfTableInfo1();
    fetchtabledetailsInfo();
    console.log(userCredentials)
  }, []);

const gridRef = useRef(null);


  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const HyperlinkCellRenderer = (props) => {
  const handleClick = () => {
    const url = `http://172.16.40.13:10002/static/${props.value}`;
    window.open(url, '_blank');
  };

  return (
    <a href="#!" onClick={handleClick} style={{ textDecoration: 'underline', color: 'blue' }}>
      {props.value}
    </a>
  );
};


 const fetchprfTableInfo1 = async () => {
    const payload = { headerconfig_id: 18,filterconditions: filterconditions  };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      let id = 0;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        sortable: true,
        filter: true,
          resizable: true,
          width: 150,
...(field.columnName === 'po_file_name' && {
          cellRenderer: HyperlinkCellRenderer, // Add custom renderer for this column
        }),

        }));

console.log("Table Column Definitions:", columns);


        settableColumnDefs(columns);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const fetchtabledetailsInfo = async () => {
    const payload = { query: `SELECT IFNULL(TRIM(prf_number), '') AS 'prf_number', IFNULL(TRIM(po_file_name), '') AS 'po_file_name', IFNULL(TRIM(po_number), '') AS 'po_number', IFNULL(TRIM(user_name), '') AS 'user_name', IFNULL(TRIM(location), '') AS 'location', IFNULL(DATE_FORMAT(requirement_date, '%d-%m-%Y'), '') AS 'requirement_date', IFNULL(TRIM(reporting_manager), '') AS 'reporting_manager', IFNULL(TRIM(department), '') AS 'department',
				IFNULL(TRIM(is_budgeted), '') AS 'is_budgeted', IFNULL(TRIM(purpose), '') AS 'purpose', IFNULL(TRIM(purchase_category), '') AS 'purchase_category', IFNULL(TRIM(purchase_type), '') AS 'purchase_type',
 				IFNULL(TRIM(date_of_delivery_expected), '') AS 'date_of_delivery_expected', IFNULL(TRIM(delivery_address), '') AS 'delivery_address', IFNULL(TRIM(benefits), '') AS 'benefits', IFNULL(TRIM(payment_term), '') AS 'payment_term', IFNULL(CONVERT(requirement_total, CHAR), '0.00') AS 'requirement_total', IFNULL(TRIM(finalized_vendor), '') AS 'finalized_vendor', IFNULL(TRIM(vendor_selection_reason), '') AS 'vendor_selection_reason', IFNULL(TRIM(approver_name),'') AS 'approver_name', IFNULL(TRIM(approver_department),'') AS 'approver_department', IFNULL(DATE_FORMAT(dept_head_approved_date, '%d-%m-%Y'), '') AS 'dept_head_approved_date',
 				IFNULL(TRIM(p2p_approver),'') AS 'p2p_approver', IFNULL(DATE_FORMAT(p2p_approved_date, '%d-%m-%Y'), '') AS 'p2p_approved_date', IFNULL(TRIM(finance_approver), '') AS 'finance_approver', IFNULL(DATE_FORMAT(finance_approved_date, '%d-%m-%Y'), '') AS 'finance_approved_date',  IFNULL(TRIM(po_status), '') AS 'po_status' FROM pouat.purchase_requirement WHERE tenant_id = ${userCredentials.tenants_id} AND group_id = ${userCredentials.groups_id} AND entity_id = ${userCredentials.entities_id} AND is_finance_approved = 1 AND is_active = 1 order by id desc;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));
	console.log("Table Row Data:", data);

        settableRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

const exportToExcel = () => {

  const gridApi = gridRef.current.api;
  const displayedRows = [];
  gridApi.forEachNodeAfterFilter((node) => {
    displayedRows.push(node.data);  // Get the filtered rows
  });
  const rowData = displayedRows;


  const filteredData1 = rowData.map((row) => {
    const { id, ...rest } = row; // Exclude the `id` column
    return rest;
  });

  const worksheet = XLSX.utils.json_to_sheet(filteredData1);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");
  XLSX.writeFile(workbook, "POreport.xlsx");
};

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
function parseDate(dateString) {
  const parsedDate = parse(dateString, 'dd-MM-yyyy', new Date());
  if (!isValid(parsedDate)) {
    return null;
  }
  return parsedDate;
}

const start = useMemo(() => (startDate ? dayjs(startDate, 'YYYY-MM-DD') : null), [startDate]);
const end = useMemo(() => (endDate ? dayjs(endDate, 'YYYY-MM-DD') : null), [endDate]);

const filteredData = useMemo(() => {
  // Parse start and end dates into timestamps (or null if invalid)
  const startTimestamp = startDate ? parse(startDate, 'yyyy-MM-dd', new Date()).getTime() : null;
  const endTimestamp = endDate ? parse(endDate, 'yyyy-MM-dd', new Date()).getTime() : null;

  return tablerowData.filter((row) => {
    const rawDate = row.requirement_date?.trim();
    
    // Validate the format of the date (avoid invalid dates early)
    if (!/^\d{2}-\d{2}-\d{4}$/.test(rawDate)) return false;

    // Convert the date to timestamp for efficient comparison
    const requirementTimestamp = parse(rawDate, 'dd-MM-yyyy', new Date()).getTime();
    if (isNaN(requirementTimestamp)) return false;

    // Apply filtering logic
    if (startTimestamp && endTimestamp) {
      return requirementTimestamp >= startTimestamp && requirementTimestamp <= endTimestamp;
    }
    if (startTimestamp) {
      return requirementTimestamp >= startTimestamp;
    }
    if (endTimestamp) {
      return requirementTimestamp <= endTimestamp;
    }

    return true; // No date filters applied
  });
}, [tablerowData, startDate, endDate]);

const exportToPDF = () => {
  const filteredColumns = tablecolumnDefs.filter((col) => col.field !== "id"); // Exclude 'id' column
  const tableColumn = filteredColumns.map((col) => col.headerName);
  const gridApi = gridRef.current.api;
  const displayedRows = [];
  gridApi.forEachNodeAfterFilter((node) => {
    displayedRows.push(node.data);  // Get the filtered rows
  });

  const tableRows = displayedRows.map((row) =>
    filteredColumns.map((col) => row[col.field] !== undefined ? row[col.field] : null)
  );

  const customWidth = 650; // Adjust width (in mm or points) to accommodate all columns
  const customHeight = 297; // Standard A4 height for landscape mode

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [customWidth, customHeight], // Set custom page size
  });

  // Add image to the document
  const imgWidth = 28; // Adjust the width of the image
  const imgHeight = 14; // Adjust the height of the image
  const imgX = 10; // X-coordinate for the image
  const imgY = 5; // Y-coordinate for the image

  doc.addImage(logo, "PNG", imgX, imgY, imgWidth, imgHeight);

  // Add header text
  doc.setFontSize(10);
  doc.text("Purchase Requirement Report", 300, 10); // Adjust position to leave space for the image

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 20,
    theme: "grid",
    styles: {
      fontSize: 5, // Reduce font size for compact layout
      cellPadding: 1, // Minimal cell padding
    },
    headStyles: {
      fillColor: [10, 35, 82], // Custom dark blue background color
      textColor: [255, 255, 255], // White text color for contrast
      fontSize: 6, // Optional: Adjust font size for headers
    },
    margin: { top: 20, left: 5, right: 5 }, // Adjust margins
    pageBreak: "auto", // Automatically manage page breaks
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  doc.save("PurchaseRequirement.pdf");
};

  if (loading) return <LoaderComponent />;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#0a2352", fontSize: '18px' }}>
        PRF REPORT
      </h2>
            <div style={{ display: 'flex', gap: '10px' }}>
            {/* <div className="col-md-7">
              <input
                className="search-input"
                type="text"
                placeholder="Search..."
                value={searchText}
                onChange={onFilterTextChange}
                style={{ width: '40%', backgroundColor: 'white',marginRight:'25px' }}
              />
            </div>
            <i
              className="fa fa-plus-circle"
              style={{ fontSize: '24px', cursor: 'pointer', color: '#007bff' }}
            ></i> */}
        <label>
          Start Date:{" "}
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label style={{ marginLeft: "1rem" }}>
          End Date:{" "}
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
          <div  style={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <input
              className="search-input"
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={onFilterTextChange}
              style={{
                width: '30%',
                backgroundColor: 'white',
                marginRight: '8px',
                marginTop: '0',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ced4da',
              }}
            />
 {/* Excel Icon */}
  <img
    src={excelIcon}
    alt="Export to Excel"
    title="Download Excel"
    onClick={exportToExcel} // Attach Excel export function
    style={{
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      marginRight: '8px',
    }}
  />
  {/* PDF Icon */}
  <Icon
    name="file pdf outline"
    title="Download PDF"
    onClick={exportToPDF} // Attach PDF export function
    style={{
      fontSize: '24px',
      color: '#d9534f',
      cursor: 'pointer',
    }}
  />
          </div>

          </div>
          <div
            className="ag-theme-alpine"
            style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${tablecolumnDefs.length * 145}px`,
              maxWidth: '100%',
              height : '650px',
              margin : '10px'
            }}
          >
            <AgGridReact
	      ref={gridRef}
              columnDefs={tablecolumnDefs}
              rowData={filteredData.length > 0 ? filteredData : tablerowData}
              style={{ width: '100%' }}
              quickFilterText={searchText}
              animateRows={true}
              pagination={true}
              paginationPageSize={14}
              enableCellTextSelection= {true}
            />
        </div>
        </div>

  );
}

export default PurchaseRequirement;
